// extracted by mini-css-extract-plugin
export default {"TextAreaForm":"TextAreaForm_TextAreaForm__wJVA-","TextAreaWrap":"TextAreaForm_TextAreaWrap__i7CSB","DynamicButtonWrapper":"TextAreaForm_DynamicButtonWrapper__kfqmk"};